import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'components/Display/Amount';

const Percentage = ({ data }) => {
  return (
    <span><Amount data={data}/> %</span>
  );
};

Percentage.propTypes = {
  data: PropTypes.number,
};

export default Percentage;



// WEBPACK FOOTER //
// ./src/components/Display/Percentage.js